import React from "react";
import { useAuth } from "../../contexts/AuthContext";
import AdminDashboard from "./AdminDashboard";
import SupervisorDashboard from "./SupervisorDashboard";
import ParentDashboard from "./ParentDashboard";
import { Text } from "../../design/text";

/**
 * Role-based dashboard that renders different content based on user role
 */
const RoleBasedDashboard: React.FC = () => {
  const { role, isAdmin, isMonitor, isParent, loading } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center h-64">
        <Text>Loading...</Text>
      </div>
    );
  }

  if (isAdmin) {
    return <AdminDashboard />;
  }

  if (isMonitor) {
    return <SupervisorDashboard />;
  }

  if (isParent) {
    return <ParentDashboard />;
  }

  // Fallback - shouldn't happen if auth is working correctly
  return (
    <div className="flex items-center justify-center h-64">
      <Text className="text-zinc-500">Unknown role: {role}</Text>
    </div>
  );
};

export default RoleBasedDashboard;
